
import { AxiosResponse } from 'axios';
import Ecosystem from '../../models/ecosystem.model';
import talentApi from './talent-api-config';
import { Career } from '../../models/career.model';

class EcosystemApi {

    async fetchEcosystemsData(): Promise<AxiosResponse<Ecosystem[]>> {
        return talentApi.get<Ecosystem[]>(`/dmq/ecosystems/`);
    }

    async fetchCareerData(): Promise<AxiosResponse<Career[]>> {
        return talentApi.get<Career[]>(`/dmq/career/`);
    }

}

export const ecosystemApi = new EcosystemApi();
